// CRATELAB Changelog
//
// Edit this list to add a new release entry. The `WhatsNewModal` shows the
// most recent entry whose `key` the user has not yet acknowledged
// (acknowledgements are stored in localStorage under `cratelab_seen_changelog`).
//
// Format:
//   key:    unique identifier for the release (used for "seen" tracking)
//   version: human-readable version string shown in the modal
//   date:    YYYY-MM-DD
//   highlights: array of bullet strings (each starts with a verb)
//   tagline: optional one-line summary shown under the version

export const CHANGELOG = [
  {
    key: 'v1.1.0',
    version: '1.1.0',
    date: '2026-04-26',
    tagline: 'Bigger libraries. Smoother sync. Lock-screen perfect.',
    highlights: [
      'macOS Apple Silicon DMG — download CRATELAB on M1/M2/M3 Macs.',
      'Lock-screen audio fixed — the player no longer drops when your phone locks.',
      'Smarter sync — the diff picker now carries crates and playlists with it.',
      'Honest crate counts — empty crates show 0 again instead of stale numbers.',
      'Auto-update — new builds reach you automatically with one click.',
      'New "Full Sync (Mirror)" button on the desktop sync screen.',
    ],
  },
];
